import { AnalisisLaboratorioResponse } from "../../../../modulos/fertilizacion/response/AnalisisLaboratorioResponse";
import { ClienteFincaLoteResponse } from "../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { formatFechaCorta } from "../../../../utils/fechaUtils";
import { BaseFullScreenModalRender } from "../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../definitions/IConnectRender";
import { FertilizacionPlanCompraRender } from "../detail/FertilizacionPlanCompraRender";

/** Modal a pantalla completa con el plan de compra de un análisis. Se abre
 *  **encima** del diagnóstico, así su botón "atrás" vuelve ahí — el "volver al
 *  diagnóstico" sale del apilado, sin navegación propia. */
export class FertilizacionPlanCompraModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "fertilizacionPlanCompraModal";

  /**
   * @param _analisis Análisis con la recomendación ya generada.
   * @param _lotes    Lotes de la finca.
   */
  constructor(
    private readonly _analisis: AnalisisLaboratorioResponse,
    private readonly _lotes: ClienteFincaLoteResponse[],
  ) {
    super();
  }

  protected get title(): string {
    return "Plan de compra";
  }

  /** Finca · fecha del análisis. */
  protected get subtitle(): string | undefined {
    const finca = serviceProvider.getFincaSelectedService().get()?.nombreFinca;
    const fecha = formatFechaCorta(this._analisis.fechaAnalisis);
    return [finca, fecha].filter(Boolean).join(" · ");
  }

  protected getContent(): IConnectRender {
    return new FertilizacionPlanCompraRender(this._analisis, this._lotes);
  }
}
